export default __webpack_public_path__ + "static/sobre-tecalis_01-14e999bea73619612c3badb66365bca9.png";